"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/common-components/lib/iframe.ts
function parsePostMessageData(data) {
  let result;
  try {
    result = JSON.parse(data);
  } catch (err) {
  }
  return result;
}



exports.parsePostMessageData = parsePostMessageData;
//# sourceMappingURL=chunk-AX2PLGGF.js.map